import { render } from "./MainDinhDanhXacThuc.vue?vue&type=template&id=207ff2ac"
import script from "./MainDinhDanhXacThuc.vue?vue&type=script&lang=js"
export * from "./MainDinhDanhXacThuc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__